import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export const selector = '.home'

export default (
    el = null
) => {
    if (!el)
        return

    const wallpaper = el
        .querySelector('.hero-home-item-wallpaper')

    if (!wallpaper)
        return

    console.groupCollapsed('Homepage')

    const video = wallpaper
        .querySelector('video')

    const btn = el
        .querySelector('.global-header-sound')

    const btnText = btn
        .querySelector('span')

    const btnUpd = () => {
        btnText.textContent = video.muted
            ? 'off'
            : 'on'
    }

    const checkAudio = () => {
        const hasAudio = video
            && (video.mozHasAudio
                || Boolean(video.webkitAudioDecodedByteCount)
                || Boolean(video.audioTracks && video.audioTracks.length))

        if (!hasAudio || !btn)
            return

        btn.classList.toggle('opacity-0')

        btn.addEventListener('click',
            videoCtrl)

        ScrollTrigger.create({
            trigger: wallpaper,
            onLeave: () => {
                video.muted = true

                btnUpd()
            }
        })
    }

    const videoCtrl = () => {
        video.muted = !video.muted

        if (!btnText)
            return

        btnUpd()
    }

    if (video)
        video.readyState
            ? checkAudio()
            : video.onloadeddata = () => {
                checkAudio()
            }

    if (import.meta.hot)
        import.meta.hot
            .on('vite:beforeUpdate', () => {
                if (btn)
                    btn.removeEventListener('click',
                        videoCtrl)
            })

    // Log instance
    console.log(wallpaper)

    console.groupEnd()

    return el
}
